export const CheckInStatus = {
  NOT_YET_OPEN: 'NOT_YET_OPEN',
  ENABLED: 'ENABLED',
  EXPIRED: 'EXPIRED',
  CHECKED_IN: 'CHECKED_IN'
}

export const CHECK_IN_UI = {
  [CheckInStatus.NOT_YET_OPEN]: {
    buttonEnabled: false,
    buttonLabel: 'Check-in opens 30 mins before',
    helperText: 'Check in when you arrive to unlock building access'
  },
  [CheckInStatus.ENABLED]: {
    buttonEnabled: true,
    buttonLabel: 'Check In',
    helperText: 'Check in when you arrive to unlock building access'
  },
  [CheckInStatus.EXPIRED]: {
    buttonEnabled: false,
    buttonLabel: 'Check-in closed',
    helperText: null
  },
  [CheckInStatus.CHECKED_IN]: {
    buttonEnabled: false,
    buttonLabel: 'Checked In',
    helperText: null
  }
}
